'use client'

import { Separator as SeparatorPrimitive } from '@base-ui/react/separator'

import { cn } from '@repo/ui/lib/utils'

function Separator({ className, orientation = 'horizontal', ...props }: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      className={cn(
        'shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch',
        className,
      )}
      data-slot="separator"
      orientation={orientation}
      {...props}
    data-sentry-element="SeparatorPrimitive" data-sentry-component="Separator" data-sentry-source-file="separator.tsx" />
  )
}

export { Separator }
